import { useEffect, useState } from 'react';

import { getKPIPointsOnline } from 'services/dashboard.service';

import { lerPontosPorComportamento, PontosPorComportamento } from './perfil-calculos';

/**
 * Pontos recebidos por comportamento no ciclo filtrado. Uma leitura só, que
 * alimenta "Pontos por comportamento" (Resumo) e "Dimensões do Comportamento"
 * (Reconhecimentos).
 */
export function usePontosPorComportamento(playerId?: string, filtro?: object) {
  const [pontos, setPontos] = useState<PontosPorComportamento>(lerPontosPorComportamento());

  useEffect(() => {
    if (!playerId) return;

    let ativo = true;

    getKPIPointsOnline(playerId, filtro)
      .then(resultado => ativo && setPontos(lerPontosPorComportamento(resultado)))
      .catch(() => ativo && setPontos(lerPontosPorComportamento()));

    return () => {
      ativo = false;
    };
  }, [playerId, filtro]);

  return pontos;
}
